import {MainRequest} from 'Services/common';

export interface GetWebSiteList extends PaginationAntD {}
export interface WebSiteList {
    expireTime: string; //    计划下次爬取时间
    sitename: string; //    网站名称
    baseDomainUrl: string; //    基础url
    id: string; //    id
}

export function getWebSitePage(params?: GetWebSiteList) {
    return MainRequest.post<SuccessData<WebSiteList[]>>(
        '/bigdata/getWebsites',
        {
            ...params,
            pageNo: params?.current,
            pageSize: params?.pageSize,
        },
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                data: res,
                total: res?.length,
            };
        });
}

export interface WebSiteEntityItem {
    id?: string;
    sitename: string; //    网站名称
    baseDomainUrl: string; //    基础url
}
//编辑网站
export function editWebSite(data: WebSiteEntityItem) {
    return MainRequest.post('/bigdata/saveWebsite', data);
}

//删除网站
export function deleteWebSite(id: string) {
    return MainRequest.post(`/bigdata/deleteWebsite`, {
        id,
    });
}
